// Homepage FAQ content. Rendered by AppFAQSection on the homepage and mirrored
// as FAQPage JSON-LD in src/app/page.jsx — keep the two in sync by editing
// only this file. Every claim here must match what the product pages state.
export const homeFaqs = [
  {
    question: "What is Keystone?",
    answer:
      "Keystone is a suite of three premium Shopify apps: Loyalty & Rewards, Product Options & Variants, and AI SEO. Each app installs from the Shopify App Store and works on its own, so you can start with the one that fits your store and add the others as you grow.",
  },
  {
    question: "Which Shopify apps does Keystone offer?",
    answer:
      "Keystone Loyalty & Rewards runs points, VIP tiers and referral programs that turn one-time buyers into repeat customers. Keystone Product Options & Variants adds unlimited product options past Shopify's 100-variant limit. Keystone AI SEO automates meta tags, alt text and structured data so your store gets surfaced by Google and by AI assistants.",
  },
  {
    question: "Do Keystone apps have a free plan?",
    answer:
      "Yes. Each app has a free plan you can start on, and paid plans come with a 14-day free trial, so you can test every feature before paying anything.",
  },
  {
    question: "Do I need to know how to code to use Keystone apps?",
    answer:
      "No. All three apps are set up from a visual dashboard inside Shopify admin — layouts, program rules and storefront widgets are configured without touching code.",
  },
  {
    question: "How does Keystone Loyalty & Rewards keep customers coming back?",
    answer:
      "Customers earn points for purchases, signups, birthdays and referrals, then redeem them for discounts, free shipping, free products and VIP-tier perks. The app is fully compatible with Shopify POS, so rewards work in-store as well as online.",
  },
  {
    question:
      "How does Keystone Product Options work around Shopify's variant limit?",
    answer:
      "Instead of creating variants, the app attaches unlimited options to your products — text fields, color and image swatches, file uploads and conditional logic — with add-on pricing and B2B price rules, so a single product can offer far more combinations than Shopify's built-in 100-variant cap allows.",
  },
  {
    question: "What does Keystone AI SEO automate for my store?",
    answer:
      "It generates and maintains meta titles, meta descriptions, image alt text and structured data across your catalog, keeping your store optimized for Google search and for AI answer engines without manual SEO work.",
  },
  {
    question: "Where can I find documentation for Keystone apps?",
    answer:
      "Setup guides and reference documentation for all three apps live at key-stone.app/docs, release notes are published in the changelog, and free tools like the loyalty ROI calculator are at key-stone.app/tools. For anything else, reach the team through the contact form on this page.",
  },
];
